/* istanbul ignore file */
import { FormSection, FormRow } from 'framework/ui/layout';
import { TextInput } from 'framework/form';
import { EmployeeInput, buildEmployeeAutoSuggestLabel } from 'domain/shared/employee';
import { snakeCase } from 'lodash';

const ServiceCatalogForm = () => {
  return (
    <>
      <FormSection title="Service information">
        <FormRow>
          <TextInput source="name" label="Name" />
          <EmployeeInput
            source="owner"
            label="Owner"
            nameSource="employeeName"
            mapResults={(employee: any) => ({
              id: employee.alias,
              text: buildEmployeeAutoSuggestLabel(employee),
              office: employee.office ? snakeCase(employee.office).toUpperCase() : null,
            })}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

export default ServiceCatalogForm;
